export const PricingScreen = () => {
    return (
        <h1>Pricing</h1>
    );
}